'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js';
import qs from 'qs';

export default {
  fetchStatuses (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/response-statuses', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
        showProgressBar: false
      })
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  },

  updateStatuses (statuses) {
    return Axios.put('/1.0/response-statuses', { statuses })
      .then(response => parseResponse(response).data)
      .catch(err => {
        return Promise.reject(err.response)
      })
  },

  createStatuses (statuses) {
    return Axios.post('/1.0/response-statuses', { statuses })
      .then(response => parseResponse(response).data)
      .catch(err => {
        return Promise.reject(err.response)
      })
  },

  deleteStatuses (statuses) {
    return new Promise((resolve, reject) => {
      Axios.delete('/1.0/response-statuses', { data: { statuses } })
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  },

  fetchStages (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/response-stages', { params, showProgressBar: false })
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  },

  fetchUserRoles (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/user-roles', { params })
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  },

  fetchInviteStatuses (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/invite-statuses', { params })
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)))
    })
  }
}
